import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_ENDPOINT } from '../constants/apiConstants';
import { useAuth } from '../contexts/AuthContext';

const LoadingFullscreen = () => {
    const { auth, setUserData } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get(`${API_ENDPOINT}/users/me`, {
                    headers: { Authorization: `${auth.token}` }
                });
                setUserData(response.data);
                console.log("fetchUserData response:", response.data);
            } catch (error) {
                console.error("Failed to fetch user data", error);
                navigate('/');
            }
        };

        if (auth.token && !auth.userData?.role) {
            fetchUserData();
        } else if (auth.userData && auth.userData.role) {
            switch (auth.userData.role) {
                case "entry":
                    navigate('/entry');
                    break;
                case "screen":
                    navigate('/screen');
                    break;
                case "producer":
                    navigate('/producer');
                    break;
                case "omni":
                    navigate('/omni');
                    break;
                default:
                    return;
            }
        }
    }, [auth.userData, navigate]);

    return <div>Loading...</div>;
};

export default LoadingFullscreen;
